import React from 'react';

export default class CustomComponent extends React.Component
{
    static custom = true;
}